import { WorkspaceSearchItem } from "~/.server/api/routers/workspace";
import { WorkspaceBreadcrumb } from "./breadcrumb";
import WorkspaceMap from "./map";
import { SortSelect, type SortProps } from "./sorting";
import { WorkspaceCard } from "./workspaceListItems";
import { MapBounds } from "~/utils/mapCache";

export default function WorkspaceListLayout({ 
  title,
  subtitle,
  children, 
  showMap = false,
  workspaces,
  totalCount,
  sort,
  showBreadcrumbs = true,
  searchWithinBounds = false,
  onBoundsChange,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  showMap?: boolean;
  workspaces: WorkspaceSearchItem[];
  totalCount?: number;
  sort?: SortProps;
  showBreadcrumbs?: boolean;
  searchWithinBounds?: boolean;
  onBoundsChange?: (bounds: MapBounds) => void;
}) {
  return (
<div className="w-full bg-background">
      <div className="container px-4 py-6">
        {showBreadcrumbs && <WorkspaceBreadcrumb />}
        <div className={`grid grid-cols-1 ${showMap ? 'lg:grid-cols-[1fr,40%]' : ''} gap-6`}>
          <div className="w-full">
            <div className="flex justify-between items-center mb-6">
              <div className="flex flex-col">
                <h2 className="text-2xl font-bold">{title}</h2>
                {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
                {totalCount !== undefined && (
                  <span className="text-sm text-muted-foreground">
                    {totalCount} espacios encontrados
                  </span>
                )}
              </div>
              {sort && <SortSelect {...sort} />}
            </div>
            {children ? (
              children
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
                {workspaces.map((space) => <WorkspaceCard {...space} key={space.id} />)}
              </div>
            )}
          </div>

          {showMap && (
            <div className="hidden lg:block sticky top-4 h-[calc(100vh-2rem)]">
              <WorkspaceMap
                key={workspaces.length > 0 ? `map-${workspaces[0].citySlug || workspaces[0].id}` : 'empty-map'}
                workspaces={workspaces}
                height="h-[600px]"
                className="mt-4"
                searchWithinBounds={searchWithinBounds}
                onBoundsChange={onBoundsChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
